export default __webpack_public_path__ + "static/media/Z15.16074e00.png";